import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';
import { CRS, CrsKind } from '@birdi/types/crs';

// matching model and router
export interface SearchParams {
  wgs84bbox?: number[] | null;
  epsgCode?: number | string;
  name?: string;
  authority?: string;
  priorityOnly?: boolean;
  kind?: CrsKind | CrsKind[];
}

export const search = async (
  st: SpanTag,
  strootId: string,
  params: SearchParams,
): Promise<APIResponse<CRS[]>> => {
  const { wgs84bbox, epsgCode, name, authority, priorityOnly } = params;

  if (!epsgCode && !wgs84bbox && !name) {
    // TODO handle error
    throw new Error('No wgs84bbox or EPSG code or EPSG name provided');
  }

  const searchParams = new URLSearchParams({
    ...(wgs84bbox && { wgs84bbox: JSON.stringify(wgs84bbox) }),
    ...(authority && { authority }),
    ...(epsgCode && { epsgcode: epsgCode.toString() }),
    ...(name && { name }),
    ...(priorityOnly && { priorityonly: priorityOnly.toString() }),
  });

  const url = new URL(`${config.API_URL}/v1/crs`);
  url.search = searchParams.toString();

  const options: APIResponse<CRS[]> = await fetchAPI(
    stleaf(st, strootId),
    url,
    {
      method: 'GET',
      credentials: 'include',
      headers,
    },
  );
  return options;
};

/** One CRS by spatial_ref_sys srid (EPSG or BIRDI); 404 when unknown. */
export const getBySrid = async (
  st: SpanTag,
  strootId: string,
  srid: number,
): Promise<APIResponse<CRS>> => {
  const url = new URL(`${config.API_URL}/v1/crs/srid/${srid}`);
  return fetchAPI(stleaf(st, strootId), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  });
};
